import {Box, Divider} from '@mui/material';
import WidgetSectionTitle from 'pages/uiwisePages/UiWiseWidget/WidgetSectionTitle';
import PropTypes from 'prop-types';

const AppFormSection = ({title}) => {
  return (
    <Box>
      <Divider
        sx={{
          mb: 4,
          mt: 4,
          borderColor: 'divider',
        }}
      />

      <WidgetSectionTitle title={title} />
    </Box>
  );
};

AppFormSection.propTypes = {
  title: PropTypes.string,
};

export default AppFormSection;
